import React, { useCallback } from "react";
import { Button } from "components";
import { useTranslate } from "hooks";
import NiceModal from "@ebay/nice-modal-react";
import { SpecificationTextModal } from "components/_Modals/SpecificationTextModal";
import { useProductOutput } from "stores/product";

export const SpecificationTextButton = () => {
  const translate = useTranslate();
  const productOutput = useProductOutput();
  const orderCode = productOutput?.product?.orderCode;
  const specificationText = productOutput?.specificationText?.text;
  const pimId = productOutput?.productImageList?.productImages?.find(
    (image) => image?.typ === "ProductPhoto",
  )?.pimId;

  const toggleSpecificationTextModal = useCallback(
    () =>
      NiceModal.show(SpecificationTextModal, {
        pimId: pimId ?? undefined,
        productName: orderCode?.key,
        specificationText: specificationText ?? undefined,
      }),
    [orderCode?.key, pimId, specificationText],
  );

  return (
    <Button
      data-testid="product-configurator-view-specification-btn-back-to-proj-mode"
      onClick={toggleSpecificationTextModal}
      color="outline-dark"
    >
      {translate("PRODUCT_CONFIGURATOR_VIEW_SPECIFICATION")}
    </Button>
  );
};
